import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseButtonContext = /*#__PURE__*/createContext(undefined);
export const CloseButtonProvider = ({
  dialogButtonStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    dialogButtonStyleOverrides
  }), [dialogButtonStyleOverrides]);
  return /*#__PURE__*/_jsx(CloseButtonContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `CloseButton` component.
 * Note: The context is only available when the `CloseButton` component is rendered as an ancestor.
 * @returns CloseButtonContext - The context for the `CloseButton` component.
 * @returns CloseButtonContext.dialogButtonStyleOverrides - Style overrides to be applied to the `DialogButton` component.
 */
export const useCloseButtonContext = () => {
  const closeButtonContext = useContext(CloseButtonContext);
  return closeButtonContext;
};